import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '../styles'

/**
 *
 * @param {number} size size icon
 * @param {string} color color hexadecimal
 * @returns {React.Component}
 */
const IcRotateRight = ({ size, color }) => {
  return (
    <Icon
      className="IcRotateRight material-icons tw-block tw-flex tw-items-center tw-justify-center"
      size={size}
      color={color}
    >
      rotate_right
    </Icon>
  )
}

IcRotateRight.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired
}

export default IcRotateRight
